export const TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES = 'TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES';
export const TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX = 'TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX';
export const TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP = 'TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP';
export const TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS = 'TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS';
